export default __webpack_public_path__ + "static/media/rolands-admidins-with-drinks.650efbb8.png";